import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAt, faCalendarAlt, faHashtag, faSave, faTimes } from '@fortawesome/free-solid-svg-icons';

class Crear extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        tipo_identificacion: '',
        identificacion: '',
        nombre: '',
        fecha_nacimiento: '',
        edad: '',
        sexo: '',
        ocupacion: '',
        direccion: '',
        barrio: '',
        correo_electronico: '',
        celular: '',
        nombre_acudiente: '',
        parentesco: '',
        ocupacion_acudiente: '',
        direccion_acudiente: '',
        celular_acudiente: '',
        estado: '',
        errors: [],
    }
    changeValue = (e) => {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState({ state, errors: [] })
    }
    errorVerify(element) {
        return this.state.errors.indexOf(element) !== -1;
    }
    sendData = (e) => {
        e.preventDefault();
        const { tipo_identificacion, identificacion, nombre, fecha_nacimiento, edad, sexo,
                ocupacion, direccion, barrio, correo_electronico, celular, nombre_acudiente,
                parentesco, ocupacion_acudiente, direccion_acudiente, celular_acudiente, estado } = this.state;
        var errors = [];
        if (!tipo_identificacion) { errors.push("error_tipo_identificacion"); }
        if (!identificacion) { errors.push("error_identificacion"); }
        if (!nombre) { errors.push("error_nombre"); }
        if (!estado) { errors.push("error_estado"); }
        if (!celular) { errors.push("error_celular"); }
        console.log(errors.length);
        this.setState({ errors: errors });
        if (errors.length > 0) {
            return false;
        }
        var data = {
            tipo_identificacion: tipo_identificacion,
            identificacion: identificacion,
            nombre: nombre,
            fecha_nacimiento: fecha_nacimiento,
            edad: edad,
            sexo: sexo,
            ocupacion: ocupacion,
            direccion: direccion,
            barrio: barrio,
            correo_electronico: correo_electronico,
            celular: celular,
            nombre_acudiente: nombre_acudiente,
            parentesco: parentesco,
            ocupacion_acudiente: ocupacion_acudiente,
            direccion_acudiente: direccion_acudiente,
            celular_acudiente: celular_acudiente,
            estado: estado,
            id_usuario: window.localStorage.getItem('idusuario')
        }
        Swal.showLoading();
        authAxios.post("pacientes/register", data)
            .then((dataResult) => {
                console.log(dataResult)
                var status = dataResult.data.status;
                if (!status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                if (dataResult.data.status) {
                    Swal.close();
                    Swal.fire(
                        'Pacientes!',
                        dataResult.data.message,
                        'success'
                    )
                    this.props.history.push("/MasterPacientes");
                } else {
                    Swal.close();
                    Swal.fire(
                        'Pacientes!',
                        dataResult.data.message,
                        'error'
                    )
                }
            })
            .catch(console.log)
    }
    render() {
        const { tipo_identificacion, identificacion, nombre, fecha_nacimiento, edad, sexo,
                ocupacion, direccion, barrio, correo_electronico, celular, nombre_acudiente,
                parentesco, ocupacion_acudiente, direccion_acudiente, celular_acudiente, estado } = this.state;
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                <b>NUEVO PACIENTE</b>
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.sendData}>
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <hr style={{ marginBottom: 0, marginTop: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>INFORMACIÓN DEL PACIENTE</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-2">
                                                    <label htmlFor="tipo_identificacion">T. Identificación</label>
                                                    <select name="tipo_identificacion"
                                                        id="tipo_identificacion"
                                                        className={((this.errorVerify("error_tipo_identificacion")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.changeValue}>
                                                        <option value="">Seleccione el T.I.</option>
                                                        <option value="1">C.C.</option>
                                                        <option value="2">C.E.</option>
                                                        <option value="3">R.C.</option>
                                                        <option value="4">T.I.</option>
                                                        <option value="5">RUT</option>
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el T. Identificación</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="identificacion">Identificación</label>
                                                    <div className={((this.errorVerify("error_identificacion")) ? "is-invalid" : "") + " input-group input-group-sm"}>
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input type="number" name="identificacion" id="identificacion" value={identificacion}
                                                            className={((this.errorVerify("error_identificacion")) ? "is-invalid" : "") + " form-control form-control-sm"} maxLength={20}
                                                            placeholder="IDENTIFICACIÓN" aria-describedby="helpId" onChange={this.changeValue} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite la Identificación</small>
                                                </div>
                                                <div className="col-md-4">
                                                    <label htmlFor="nombre">Nombre</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="nombre" id="nombre" value={nombre}
                                                        className={((this.errorVerify("error_nombre")) ? "is-invalid" : "") + " form-control form-control-sm"}
                                                        placeholder="Nombre" aria-describedby="helpId" onChange={this.changeValue} />
                                                    <small id="helpId" className="invalid-feedback">Digite el Nombre</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="sexo">Sexo</label>
                                                    <select name="sexo"
                                                        id="sexo"
                                                        className={((this.errorVerify("error_sexo")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.changeValue}>
                                                        <option value="">Seleccione el Sexo</option>
                                                        <option value="1">FEMENINO</option>
                                                        <option value="2">MASCULINO</option>
                                                        <option value="3">OTRO</option>
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Sexo</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="estado">Estado</label>
                                                    <select name="estado"
                                                        id="estado"
                                                        className={((this.errorVerify("error_estado")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.changeValue}>
                                                        <option value="">Seleccione el Estado</option>
                                                        <option value="0">ACTIVO</option>
                                                        <option value="1">INACTIVO</option>
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Estado</small>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-2">
                                                    <label htmlFor="fecha_nacimiento">Fecha Nacimiento</label>
                                                    <div className={((this.errorVerify("error_fecha_nacimiento")) ? "is-invalid" : "") + " input-group input-group-sm"}>
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendarAlt} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="date" name="fecha_nacimiento" id="fecha_nacimiento" value={fecha_nacimiento}
                                                            className={((this.errorVerify("error_fecha_nacimiento")) ? "is-invalid" : "") + " form-control form-control-sm"}
                                                            placeholder="Fecha Nacimiento" aria-describedby="helpId" onChange={this.changeValue}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Seleccione la Fecha Nacimiento</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="edad">Edad</label>
                                                    <div className={((this.errorVerify("error_edad")) ? "is-invalid" : "") + " input-group input-group-sm"}>
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input type="number" name="edad" id="edad" value={edad}
                                                            className={((this.errorVerify("error_edad")) ? "is-invalid" : "") + " form-control form-control-sm"} maxLength={20}
                                                            placeholder="EDAD" aria-describedby="helpId" onChange={this.changeValue} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite la Edad</small>
                                                </div>
                                                <div className="col-md-4">
                                                    <label htmlFor="ocupacion">Ocupación</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="ocupacion" id="ocupacion" value={ocupacion}
                                                        className={((this.errorVerify("error_ocupacion")) ? "is-invalid" : "") + " form-control form-control-sm"}
                                                        placeholder="Ocupación" aria-describedby="helpId" onChange={this.changeValue} />
                                                    <small id="helpId" className="invalid-feedback">Digite la Ocupación</small>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-4">
                                                    <label htmlFor="direccion">Dirección</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="direccion" id="direccion" value={direccion}
                                                        className="form-control form-control-sm"
                                                        placeholder="Dirección" aria-describedby="helpId" onChange={this.changeValue} />
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="barrio">Barrio</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="barrio" id="barrio" value={barrio}
                                                        className="form-control form-control-sm"
                                                        placeholder="Barrio" aria-describedby="helpId" onChange={this.changeValue} />
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="correo_electronico">Correo Electrónico</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faAt} /></span>
                                                        <input style={{ textTransform: 'lowercase' }} type="text" name="correo_electronico" id="correo_electronico" value={correo_electronico}
                                                            className="form-control form-control-sm"
                                                            placeholder="ejemplo@dominio.com" aria-describedby="helpId" onChange={this.changeValue} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el Correo Electrónico</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="celular">Celular</label>
                                                    <div className={((this.errorVerify("error_celular")) ? "is-invalid" : "") + " input-group input-group-sm"}>
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="celular" id="celular" value={celular}
                                                            className={((this.errorVerify("error_celular")) ? "is-invalid" : "") + " form-control form-control-sm"}
                                                            placeholder="Celular" aria-describedby="helpId" onChange={this.changeValue} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el Celular</small>
                                                </div>
                                            </div>
                                            <hr style={{ marginBottom: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>INFORMACIÓN DEL ACUDIENTE</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-4">
                                                    <label htmlFor="nombre_acudiente">Nombre Acudiente</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="nombre_acudiente" id="nombre_acudiente" value={nombre_acudiente}
                                                        className={((this.errorVerify("error_nombre_acudiente")) ? "is-invalid" : "") + " form-control form-control-sm"}
                                                        placeholder="Nombre Acudiente" aria-describedby="helpId" onChange={this.changeValue} />
                                                    <small id="helpId" className="invalid-feedback">Digite el Nombre Acudiente</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="parentesco">Parentesco</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="parentesco" id="parentesco" value={parentesco}
                                                        className={((this.errorVerify("error_parentesco")) ? "is-invalid" : "") + " form-control form-control-sm"}
                                                        placeholder="Parentesco" aria-describedby="helpId" onChange={this.changeValue} />
                                                    <small id="helpId" className="invalid-feedback">Digite el Parentesco</small>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-4">
                                                    <label htmlFor="ocupacion_acudiente">Ocupación Acudiente</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="ocupacion_acudiente" id="ocupacion_acudiente" value={ocupacion_acudiente}
                                                        className={((this.errorVerify("error_ocupacion_acudiente")) ? "is-invalid" : "") + " form-control form-control-sm"}
                                                        placeholder="Ocupación Acudiente" aria-describedby="helpId" onChange={this.changeValue} />
                                                    <small id="helpId" className="invalid-feedback">Digite la Ocupación Acudiente</small>
                                                </div>
                                                <div className="col-md-4">
                                                    <label htmlFor="direccion_acudiente">Dirección Acudiente</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="direccion_acudiente" id="direccion_acudiente" value={direccion_acudiente}
                                                        className="form-control form-control-sm"
                                                        placeholder="Dirección Acudiente" aria-describedby="helpId" onChange={this.changeValue} />
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="celular_acudiente">Celular Acudiente</label>
                                                    <div className={((this.errorVerify("error_celular_acudiente")) ? "is-invalid" : "") + " input-group input-group-sm"}>
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="celular_acudiente" id="celular_acudiente" value={celular_acudiente}
                                                            className={((this.errorVerify("error_celular_acudiente")) ? "is-invalid" : "") + " form-control form-control-sm"}
                                                            placeholder="Celular Acudiente" aria-describedby="helpId" onChange={this.changeValue} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el Celular Acudiente</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <div className='col-xl-12 text-center'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="submit" className="btn btn-success btn-sm"><FontAwesomeIcon icon={faSave} />&nbsp;&nbsp;Guardar</button>&nbsp;&nbsp;
                                                <Link className="btn btn-danger btn-sm" to={"/MasterPacientes"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Crear;